import * as yup from 'yup'

export const tutorialSchema = yup.object({
	title: yup.string().trim().required(),
	description: yup.string().trim(),
	youtubeUrl: yup.string().trim().required(),
	visibility: yup.string().oneOf(['all', 'restricted']).required(),
	classIds: yup.array(),
	rules: yup.array().of(
		yup.object({
			operator: yup
				.string()
				.oneOf(['contains', 'starts_with', 'ends_with'])
				.required(),
			value: yup.string().trim().required('Escreva o texto da regra'),
		})
	),
})
